/**
 * Turn an API (axios) error into a human-readable message. The backend
 * returns problem-details style bodies (title/detail/errors) for rejected
 * commits; fall back to the transport error message when no body is present.
 * @param {*} error - Error thrown by ApiClient
 * @returns {string} Readable message, never empty
 */
export function extractApiErrorMessage(error) {
  const data = error?.response?.data;

  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }

  if (data && typeof data === 'object') {
    // Validation problem-details: { errors: { Field: ['msg', ...], ... } }
    if (data.errors && typeof data.errors === 'object') {
      const messages = Object.values(data.errors)
        .flat()
        .filter((message) => typeof message === 'string' && message.trim());
      if (messages.length) {
        return messages.join(' ');
      }
    }

    for (const key of ['detail', 'title', 'message']) {
      if (typeof data[key] === 'string' && data[key].trim()) {
        return data[key].trim();
      }
    }
  }

  return error?.message || 'An unknown error occurred.';
}
